<script>
    import {faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";
    import Fa from "svelte-fa";

    let { headerText, children } = $props();
    let expanded = $state(false);

</script>

<div class="expandable">
    <button type="button" class="header" aria-expanded={expanded} onclick={() => expanded = !expanded}>
        {#if expanded}
            <Fa icon={faChevronUp} />
        {:else}
            <Fa icon={faChevronDown} />
        {/if}
        &nbsp;<b>{headerText}</b>
    </button>

    <div class="contents" hidden={!expanded}>
        {@render children?.()}
    </div>
</div>

<style>
    .expandable {
        border: 1px solid #28647d;
        background-color: #F7F7F7;
    }

    .header {
        user-select: none;
        cursor: pointer;
        width: 100%;
        padding: 0;
        background-color: #F7F7F7;
        color: #28647d;
        text-align: left;
        border: none;
        margin: 0;
    }

    .contents {
        padding: 1em;
    }

</style>
